module.exports = __webpack_public_path__ + "assets/img/37_1616_big.49bac062.jpg";